import React from 'react';
import classnames from 'classnames';
import styles from './Checkbox.module.scss';

interface ICheckboxDisplayProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  checked?: boolean;
  disabled?: boolean;
  intermediate?: boolean;
  dataTestId?: string;
}

export const CheckboxDisplay = ({
  checked,
  intermediate,
  disabled = false,
  readOnly,
  dataTestId,
  onChange,
  children,
  ...rest
}: ICheckboxDisplayProps) => {
  return (
    <div
      {...rest}
      className={classnames(styles.container, { [styles.disabled]: disabled })}
    >
      <input
        type="checkbox"
        checked={checked}
        data-testid={dataTestId}
        disabled={disabled}
        readOnly={readOnly}
        role="checkbox"
        onChange={onChange}
      />
      <span
        className={classnames(styles.checkmark, {
          [styles.grayout]: disabled,
          [styles.lineal]: intermediate,
        })}
        data-cy="checkbox"
      />
      {children}
    </div>
  );
};

export interface CheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  keyText?: string;
  overlay?: { text: string };
  lineal?: boolean;
  inputTestId?: string;
}

const Checkbox = ({
  label = '',
  checked,
  onChange,
  keyText,
  readOnly,
  disabled,
  lineal = false,
  inputTestId = `${keyText}_input`,
}: CheckboxProps) => {
  return (
    <label key={keyText} data-testid={keyText}>
      <CheckboxDisplay
        checked={checked}
        readOnly={readOnly}
        onChange={onChange}
        disabled={disabled}
        intermediate={lineal}
        dataTestId={inputTestId}
      >
        <div
          className={styles.labelText}
          data-testid={`${keyText}_name`}
          data-cy={`activity-associations:associations_${keyText}`}
        >
          {label}
        </div>
      </CheckboxDisplay>
    </label>
  );
};

export default Checkbox;
